module.exports = __webpack_public_path__ + "42abdc78a5ee72182fc5d78e828da3f9.jpg";